import {Add, Information} from "@carbon/icons-react";
import {Button} from "@carbon/react";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {toggleModal} from "../../../features/application/applicationSlice.js";

const Index = ({chart, modalId}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const title = chart.title
    const subtitle = chart.subtitle
    const description = chart.description
    let tooltip = ''
    if (chart.tooltip || chart.user_description) {
        if (chart.subtitle) {
            tooltip = <>
                <Button
                    kind={'ghost'}
                    hasIconOnly={true}
                    renderIcon={Information}
                    iconDescription={t("common.moreInformation")}
                    onClick={() => dispatch(toggleModal(modalId))}>

                </Button>
            </>
        } else {
            tooltip = <>
                <Button
                    className={'info-action'}
                    kind={'tertiary'}
                    onClick={() => dispatch(toggleModal(modalId))}>
                    <Add size={18}/>
                    {t("common.information")}
                </Button>
            </>
        }
    }
    const default_type = <>
        <div className={'panel-title-container top-border'}>
            <h5 className="cds--cc--title">{subtitle}</h5>
            {tooltip}
        </div>
        <div className="panel-description">{description}</div>
    </>
    const table_type = <>
        <div className="cds--data-table-header">
            <div className={'panel-title-container'}>
                <h4 className="cds--data-table-header__title">{title}</h4>
                {tooltip}
            </div>
            <h5 className="cds--data-table-header__title">{subtitle}</h5>
            <div className="panel-description">{description}</div>
        </div>
    </>

    const descriptionComponent = (<div className={'chart-description'}>
        {chart.type !== 'table_chart' ? default_type : table_type}
    </div>)
    return (
        <>{descriptionComponent}</>
    )

}


export default Index
